// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-5f83969d] {\n  background-color: #ffffff;\n  overflow: auto;\n}\n.van-hairline--bottom[data-v-5f83969d]:after {\n  border-bottom-width: 0rem;\n}\n[data-v-5f83969d] .van-nav-bar__arrow {\n  color: #000000;\n}\n.agreement-text[data-v-5f83969d] {\n  padding: 0.26667rem;\n  font-size: 0.34667rem;\n}\n", ""]);
// Exports
module.exports = exports;
